module.exports = __webpack_public_path__ + "media/images/webpage/hotels/743/plan4-1-edaf798dea7f04108072514947bb231e.webp";